import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';

export const totalQuantityErrorId = 'order-item-total-quantity-error';

interface SaveBarErrorProps {
    message: string;
    messageId?: string;
    actionText?: string;
    onAction?: () => void;
    showIcon?: boolean;
}

export const SaveBarError = ({
    message,
    messageId,
    actionText,
    onAction,
    showIcon = true,
}: SaveBarErrorProps) => {
    const lineHeight = '2.4rem';

    return (
        <Box
            display="flex"
            alignItems="flex-start"
            sx={{
                color: 'text.primary',
                fontSize: '1.3rem',
                fontWeight: 400,
                lineHeight,
                minWidth: 0,
            }}
        >
            {showIcon && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        height: lineHeight,
                        marginRight: '8px',
                    }}
                >
                    <ErrorOutlineIcon
                        sx={{
                            color: 'error.main',
                        }}
                    />
                </Box>
            )}
            <Box sx={{ minWidth: 0 }}>
                {actionText && onAction && (
                    <Typography
                        component="span"
                        onClick={onAction}
                        sx={{
                            color: 'primary.main',
                            fontSize: '1.3rem',
                            fontWeight: 400,
                            lineHeight,
                            cursor: 'pointer',
                            textDecoration: 'none',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        {actionText}
                    </Typography>
                )}
                {actionText && onAction && <>&nbsp;</>}
                <Typography
                    id={messageId}
                    component="span"
                    sx={{
                        fontSize: 'inherit',
                        fontWeight: 'inherit',
                        lineHeight: 'inherit',
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};
